// extracted by mini-css-extract-plugin
export default {"SetupProviderTabs":"SetupProviderTabs_SetupProviderTabs__FrWC2","TablList":"SetupProviderTabs_TablList__Q3I+k","Panel":"SetupProviderTabs_Panel__YQC0D"};